<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-select
          class="remote-select"
          v-model="share.owner_org_id"
          filterable
          clearable
          remote
          placeholder="选择客户查询"
          @change="ownerOrgChange"
          :remote-method="getOwnerOrgList"
          :loading="ownerOrgLoading">
          <el-option
            v-for="item in share.ownerOrgList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select
          class="remote-select"
          v-model="share.device_id"
          filterable
          clearable
          remote
          placeholder="选择设备查询"
          @change="deviceChange"
          :remote-method="getDeviceList"
          :loading="deviceLoading">
          <el-option
            v-for="item in share.deviceList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :sortable="it.sortable" :sort-method="(a, b) => sortDateTime(a, b, it.key)">
          <template slot-scope="scope">
            <span v-if="it.key === 'owner_org_name' || it.key === 'device_name'">{{scope.row.device[it.key]}}</span>
            <span v-else>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange"/>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import Util from '@/api/util'

export default {
  data () {
    return Backend.initListPage(this, 'device_parameter_operate_recorder_for_log', {
      route_name: '控制记录列表',
      tableColList: [
        {
          key: 'operate_time',
          name: '操作时间',
          sortable: true
        },
        {
          key: 'user_name',
          name: '用户名'
        },
        {
          key: 'owner_org_name',
          name: '客户'
        },
        {
          key: 'device_name',
          name: '设备名称'
        },
        {
          key: 'device_parameter_name',
          name: '参数'
        },
        {
          key: 'operate_content',
          name: '操作内容'
        }
      ],
      params: {
        owner_org_id: '',
        device_id: ''
      },
      ownerOrgLoading: false,
      deviceLoading: false,
      share: {
        owner_org_id: '',
        device_id: '',
        ownerOrgList: [],
        deviceList: []
      }
    })
  },

  methods: {
    getOwnerOrgList (name) {
      if (name !== '') {
        this.ownerOrgLoading = true
        const url = `/org_customer/cmd/list/key_field/org_name/value_field/org_id/max_results/1000/org_name/${name}/text/`
        Backend.get(this, url, 0).then(data => {
          this.ownerOrgLoading = false
          this.share.ownerOrgList = data.items
        })
      } else {
        this.share.ownerOrgList = []
      }
    },
    ownerOrgChange (id) {
      this.share.device_id = ''
      this.share.deviceList = []
      this.params.owner_org_id = id
      this.params.device_id = ''
      this.onSearch()
    },
    deviceChange (id) {
      this.params.device_id = id
      this.params.owner_org_id = id === '' ? this.share.owner_org_id : ''
      this.onSearch()
    },
    getDeviceList (name) {
      if (name !== '') {
        const baseUrl = `/device/cmd/list/key_field/device_name/value_field/device_id/max_results/100/device_name/${name}`

        const id = this.params.owner_org_id
        const url = id !== '' ? `${baseUrl}/owner_org_id/${id}/text/` : `${baseUrl}/text/`
        this.deviceLoading = true
        Backend.get(this, url, 0).then(data => {
          this.deviceLoading = false
          this.share.deviceList = data.items
        })
      } else {
        this.share.deviceList = []
      }
    },
    sortDateTime (a, b, key) {
      return Util.sortDateTime(a, b, key)
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    }
  }
}
</script>
